
import { Component, Mixins, Prop } from "vue-property-decorator";
import FormLogin from "./";
import FormLoginLine from "@/components/form/FormLoginLine/FormLoginLine.vue";
const Words: Dictionary = {
  error: "所属先IDまたは所属先パスワードに誤りがあります。",
  error2: "システムエラー",
  account: "所属先ID",
  password: "所属先パスワード",
  login: "所属先IDでログイン",
};
@Component({
  components: {
    FormLoginLine,
  },
})
export default class FormLoginJa extends Mixins(FormLogin) {
  @Prop({ default: true })
  showLineLogin!: boolean;

  private words = Words;
}
